import React from "react";

const wrapper = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  padding: "24px",
  fontFamily: "sans-serif",
};

const card = {
  maxWidth: "560px",
  width: "100%",
  textAlign: "center",
};

const detail = {
  textAlign: "left",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  background: "#f6f6f6",
  border: "1px solid #e0e0e0",
  borderRadius: "4px",
  padding: "12px",
  marginTop: "16px",
  fontSize: "12px",
};

// Without this any throw during render or in a passive effect unmounts the
// whole React root and leaves a blank page with no way to recover.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled UI error", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div style={wrapper}>
        <div style={card}>
          <h2>Something went wrong</h2>
          <p>
            The page could not be displayed. Reloading usually clears this. If
            your session has ended, sign in again.
          </p>
          <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
            <button
              className="ui button"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
            <button
              className="ui primary button"
              onClick={() => window.location.assign("/login")}
            >
              Go to login
            </button>
          </div>
          <pre style={detail}>
            {this.state.error?.message ?? String(this.state.error)}
          </pre>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
